module.exports = __webpack_public_path__ + "static/img/pic4.bd9d141.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case1/pic4.jpg
// module id = DrH6
// module chunks = 1